import listmodule from './list.js';
import { ATTENDANTLIST_STATUS, ATTENDANTLIST_TWOFACTOR } from '../actions/attendantlistactions'; 
const state = {
    ...listmodule.state,
    status: null,
    twofactor:null
};

const getters = {
    ...listmodule.getters,
    status: state => state.status,
    twofactor: state => state.twofactor,
};

const actions = {
    ...listmodule.actions,
    [ATTENDANTLIST_STATUS]: ({ commit }, status) => {
        console.log('status' + status)
        commit(ATTENDANTLIST_STATUS, status);
    },
    [ATTENDANTLIST_TWOFACTOR]: ({ commit }, twofactor) => {
        console.log('twofactor' + twofactor)
        commit(ATTENDANTLIST_TWOFACTOR, twofactor);
    },
};

const mutations = {
    ...listmodule.mutations,
    [ATTENDANTLIST_STATUS]: (state, status) => {
        state.status = status;
    },
    [ATTENDANTLIST_TWOFACTOR]: (state, twofactor) => {
        state.twofactor = twofactor;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};